<div class="login-container">
  <div class="card">
    <div class="card-header text-center">
      <h2>Login</h2>
    </div>
    <div class="card-body">
      <!-- Error Message -->
      <div *ngIf="showError" class="alert alert-danger mb-3">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        {{ errorMessage }}
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <!-- Email Address -->
        <div class="form-group">
          <label for="email" class="form-label">Email Address</label>
          <div class="input-group">
            <input
              type="email"
              id="email"
              formControlName="username"
              class="form-control"
              [ngClass]="{'is-invalid': isControlInvalid('username')}"
              autocomplete="username"
             />
          </div>
          <div class="validation-message" *ngIf="isControlInvalid('username')">
            <div>Invalid email</div>
          </div>
        </div>

        <!-- Password -->
        <app-password-field
          label="Password"
          [control]="$any(form.get('password'))"
          [errorMessages]="{
            required: 'Password is required',
            minlength: 'Password must be at least 8 characters',
            maxlength: 'Password cannot exceed 50 characters'
          }"
          ngbTooltip="Enter your password"
        ></app-password-field>

        <!-- Forgot Password Link -->
        <div class="form-group text-end">
          <a class="form-link" routerLink="/forgotpassword">Forgot Password?</a>
        </div>

        <!-- Turnstile CAPTCHA -->
        <div class="form-group">
          <app-turnstile
            [siteKey]="siteKey"
            (tokenChange)="onTurnstileToken($event)"
            #turnstileWidget
          ></app-turnstile>
        </div>

        <!-- Login Button -->
        <div class="form-group text-center button-container">
          <button
            type="submit"
            class="btn  btn-submit"
            [disabled]="!isFormReady || isLoading || !turnstileToken"
          >
            Log in
          </button>
        </div>

        <!-- Sign Up Link -->
        <div class="form-group text-center mt-3">
          <div class="form-text">
            Don't have an account yet?
            <a class="form-link" routerLink="/contact-us">Contact us</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
